import { Platform, StyleSheet } from 'react-native';
import { spacing, ticketColors } from '../theme/public-api';

export const modalShellStyles = StyleSheet.create({
  keyboardRoot: {
    flex: 1,
  },
  /** Wrap del sheet mobile: sube el card con el teclado sin estirarlo a full-height. */
  keyboardSheetWrap: {
    width: '100%',
    // Acota el KAV al backdrop: sin esto el maxHeight % del sheet no resuelve en web
    maxHeight: '100%',
    justifyContent: 'flex-end',
  },
  backdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'center',
    alignItems: 'center',
    ...(Platform.OS === 'web'
      ? ({
          width: '100%',
          minHeight: '100vh' as unknown as number,
        } as const)
      : {}),
  },
  /** Bottom sheet en mobile: full-width, top-only border radius, alineado abajo. */
  bottomSheetBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'flex-end',
  },
  bottomSheetCard: {
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderTopWidth: 1,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderColor: ticketColors.ruleSoft,
    paddingTop: 8,
    width: '100%',
    overflow: 'hidden',
    zIndex: 1,
    flexDirection: 'column',
  },
  grabber: {
    width: 28,
    height: 3,
    borderRadius: 2,
    backgroundColor: ticketColors.ruleSoft,
    alignSelf: 'center',
    marginTop: 2,
    marginBottom: 12,
  },
  bottomSheetHeader: {
    paddingHorizontal: 18,
    marginBottom: 8,
  },
  bottomSheetScrollContent: {
    paddingHorizontal: 18,
    paddingBottom: spacing.lg,
    gap: spacing.md,
  },
  bottomSheetFooter: {
    flexShrink: 0,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    paddingHorizontal: 18,
    paddingTop: 12,
    paddingBottom: 18,
  },
  card: {
    backgroundColor: ticketColors.paper,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    padding: spacing.md,
    gap: spacing.sm,
    alignSelf: 'center',
    width: '100%',
    overflow: 'hidden',
    zIndex: 1,
    flexDirection: 'column',
  },
  scroll: {
    flexGrow: 0,
    flexShrink: 1,
    minHeight: 0,
  },
  bottomSheetScroll: {
    flexGrow: 0,
    flexShrink: 1,
    minHeight: 0,
  },
  scrollContent: {
    gap: spacing.sm,
  },
  footer: {
    flexShrink: 0,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    paddingTop: spacing.sm,
    marginTop: spacing.sm,
  },
});
